import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "@/store";
import { env } from "@/config";

class ApiUtils {
  static apiQuery = (path: String = "/") => {
    const baseUrl = env.apiBaseUrl;
    if (!baseUrl) throw new Error("Failed to find the REACT_APP_API_BASE_URL");

    return fetchBaseQuery({
      baseUrl: baseUrl + path,
      prepareHeaders: (headers, { getState }) => {
        const {
          auth: { token },
        } = (getState as typeof store.getState)();

        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
          headers.set("Time-Zone", env.timeZone ?? "UTC");
        }

        return headers;
      },
    });
  };

  static getUrl = (url: string, params: any) => {
    const data = Object.entries(params).map(([name, value]) => ({
      name,
      value,
    }));
    return data?.filter((item) => !!item.value)?.length > 0
      ? ApiUtils.joinToString(data, "&", url + "?", "", (item) =>
        item.value ? `${item.name}=${item.value}` : "",
      )
      : url;
  };

  static joinToString<T>(
    array: T[],
    separator = ",",
    prefix = "",
    suffix = "",
    transform: (item: T) => string,
  ) {
    let res = prefix;
    for (let i = 0; i < array.length; i++) {
      if (i !== 0 && transform(array[i]) !== "") {
        res += separator;
      }
      res += transform(array[i]);
    }
    res += suffix;
    return res;
  }

  static arraysEqual(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  }
}

export default ApiUtils;
